import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Award, Wallet, Headphones } from 'lucide-react';
import { whyChooseUs } from '../data/mockData';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import MobileSlider from './MobileSlider';

const WhyChooseUsSection = ({ onOpenContactForm }) => {
  const header = useScrollAnimation({ threshold: 0.15 });
  const left = useScrollAnimation({ threshold: 0.1 });
  const right = useScrollAnimation({ threshold: 0.1 });
  const icons = [Award, Wallet, Headphones];

  const uspCards = whyChooseUs.map((item, index) => {
    const Icon = icons[index];
    return (
      <div key={item.id} data-testid={`why-choose-card-${item.id}`} className="group hover-soft border border-[#E2E2F0] bg-white rounded-2xl p-6 flex gap-5 h-full">
        <div className="w-11 h-11 border border-[#E2E2F0] bg-[#F5F3FF] rounded-xl flex items-center justify-center flex-shrink-0">
          <Icon className="w-5 h-5 text-[#6366F1]" strokeWidth={1.5} />
        </div>
        <div>
          <h4 className="text-lg font-semibold text-[#1E1B4B] mb-1.5" style={{fontFamily:"'Playfair Display',serif"}}>{item.title}</h4>
          <p className="text-sm font-normal text-[#4B5563] leading-relaxed">{item.description}</p>
        </div>
      </div>
    );
  });

  const statCards = [
    { value: '97%', label: 'Filing approval rate', detail: 'vs. 55% average for self-filed applications' },
    { value: '24h', label: 'Guaranteed response time', detail: 'Dedicated case manager on every filing' },
    { value: '5,000+', label: 'Trademarks secured', detail: 'For startups, sellers, and enterprise brands' },
  ].map((s, i) => (
    <div key={i} className="group bg-[#1E1B4B] rounded-2xl p-6 cursor-default hover-soft h-full">
      <span className="text-3xl font-bold text-[#C4B5FD] block mb-1" style={{fontFamily:"'Playfair Display',serif"}}>{s.value}</span>
      <span className="text-sm font-medium text-white block mb-1">{s.label}</span>
      <span className="text-xs text-white/50 font-normal">{s.detail}</span>
    </div>
  ));

  return (
    <section data-testid="why-choose-section" className="py-16 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={header.ref} className={`mb-10 md:mb-16 scroll-fade-up ${header.isVisible?'scroll-visible':''}`}>
          <span className="text-xs tracking-[0.2em] uppercase text-[#6366F1] mb-3 block font-semibold">Our Distinction</span>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#1E1B4B] leading-tight mb-4" style={{fontFamily:"'Playfair Display',serif"}}>Precision. Transparency. Accountability.</h2>
          <p className="text-base font-normal text-[#4B5563] leading-relaxed max-w-lg">We combine the rigor of a traditional law firm with the efficiency and transparency that modern businesses expect.</p>
        </div>

        {/* Desktop */}
        <div className="hidden md:grid lg:grid-cols-2 gap-5">
          <div ref={left.ref} className={`space-y-4 scroll-slide-left ${left.isVisible?'scroll-visible':''}`}>{uspCards}</div>
          <div ref={right.ref} className={`space-y-4 scroll-slide-right scroll-delay-2 ${right.isVisible?'scroll-visible':''}`}>{statCards}</div>
        </div>

        {/* Mobile — sliders */}
        <div className="md:hidden space-y-8">
          <MobileSlider>{uspCards}</MobileSlider>
          <MobileSlider>{statCards}</MobileSlider>
        </div>

        <div className="mt-10 md:mt-12">
          <Button data-testid="why-choose-cta" onClick={onOpenContactForm} className="btn-gradient text-white font-semibold px-8 py-5 text-sm rounded-full group">
            Schedule a Consultation <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
          </Button>
        </div>
      </div>
    </section>
  );
};
export default WhyChooseUsSection;
